import { createSharedSlice } from '@luna/state';

const initialState: { title: string | undefined } = {
    title: undefined,
};

export const usePageTitleOverride = createSharedSlice({
    name: 'page-title-override',
    initialState,
    reducers: {
        setTitle: (state, { payload }: { payload: string }) => {
            state.title = payload;
        },
        removeTitle: (state) => {
            state.title = undefined;
        },
    },
});

export const setPageTitle = usePageTitleOverride.dispatchActions.setTitle;
export const removePageTitle = usePageTitleOverride.dispatchActions.removeTitle;
